import { createAction, props } from '@ngrx/store';

const GET_TECHNOLOGY_STACK = '[TechnologyStack] Get TechnologyStack';
const GET_MEMBER_APPS = '[TechnologyStack] Get MemberApps';
const GET_TECHNOLOGY_STACK_SUITEID = '[TechnologyStack] Get TechnologyStack By SuiteId';
const GET_APP_METAINFO = '[TechnologyStack] Get AppMetaInfo';
const SENT_TECHNOLOGY_STACK = '[TechnologyStack] Sent TechnologyStack';
const SET_TECHNOLOGY_STACK = '[TechnologyStack] Set TechnologyStack';
const SET_APP_METAINFO = '[TechnologyStack] Set AppMetaInfo';
const SET_MEMBER_APPS = '[TechnologyStack] Set MemberApps';
const SAVE_TECHNOLOGY_STACK = '[TechnologyStack] Save TechnologyStack';
const CREATE_APP_METAINFO = '[AppMetaInfo] Create AppMetaInfo';
const DELETE_APP_METAINFO = '[AppMetaInfo] Delete AppMetaInfo';
const SENT_UPDATE_TECHNOLOGY_STACK = '[TechnologyStack] Sent Update TechnologyStack';
const UPDATE_TECHNOLOGY_STACK = '[TechnologyStack] Update TechnologyStack';
const DELETE_TECHNOLOGY_STACK = '[TechnologyStack] Delete TechnologyStack';

const GET_APP_SETTINGS = '[AppSettings] Get AppSettings';

const GET_SHARED_DATABASES = '[AppSettings] Get SharedDbs';

const SENT_APP_SETTINGS = '[AppSettings] Sent AppSettings';
const SET_APP_SETTINGS = '[AppSettings] Set AppSettings';
const SAVE_APP_SETTINGS = '[AppSettings] Save AppSettings';
const SENT_UPDATE_APP_SETTINGS = '[AppSettings] Sent Update AppSettings';
const UPDATE_APP_SETTINGS = '[AppSettings] Update AppSettings';
const DELETE_APP_SETTINGS = '[AppSettings] Delete AppSettings';
const SET_SHARED_DB = '[AppSettings] Set SharedDbs';
const GET_ENVIRONMENTS = '[Environments] Get Environments';
const GET_ENVIRONMENTS_DB = '[Environments] Get Environments With Db';
const GET_ENVIRONMENTS_SUITEID = '[Environments] Get Environments By SuiteId';
const SET_ENVIRONMENTS = '[Environments] Set Environments';
const SET_ENVIRONMENTS_MEM = '[Environments] Set Environments Mem';
const SENT_ENVIRONMENTS = '[Environments] Sent Environments';
const SAVE_ENVIRONMENTS = '[Environments] Save Environments';
const NEW_ENV_CREATED = '[Environments] Newly Created Environments';
const SENT_UPDATE_ENVIRONMENTS = '[Environments] Sent Update Environments';
const UPDATE_ENVIRONMENTS = '[Environments] Update Environments';
const SENT_DELETE_ENVIRONMENTS = '[Environments] Sent Delete Environments';
const DELETE_ENVIRONMENTS = '[Environments] Delete Environments';
const DELETE_ENVIRONMENTS_FAILURE = '[Environments] Delete Environments Failure';

const getTechnologyStack = createAction(GET_TECHNOLOGY_STACK, props<{ apiConstants: any; appId: string }>());

const getMemberApps = createAction(GET_MEMBER_APPS, props<{ apiConstants: any; params: any }>());

const getTechnologyStackBySuiteId = createAction(
  GET_TECHNOLOGY_STACK_SUITEID,
  props<{ apiConstants: any; params: any }>()
);
const getAppMetaInfo = createAction(GET_APP_METAINFO, props<{ apiConstants: any }>());

const setTechnologyStack = createAction(SET_TECHNOLOGY_STACK, props<{ technologyStackData: any }>());

const setMemberApps = createAction(SET_MEMBER_APPS, props<{ memberApps: any }>());

const setAppMetaInfo = createAction(SET_APP_METAINFO, props<{ metaInfoData: any }>());

const saveTechnologyStack = createAction(SAVE_TECHNOLOGY_STACK, props<{ technologyStackData: any }>());

const createAppMetaInfo = createAction(CREATE_APP_METAINFO, props<{ apiConstants: any; appMetaInfoData: any }>());
const deleteAppMetaInfo = createAction(DELETE_APP_METAINFO, props<{ apiConstants: any; modelId: any }>());
const sentTeckStack = createAction(SENT_TECHNOLOGY_STACK, props<{ apiConstants: any; saveTechStackData }>());
const sentUpdateTeckStack = createAction(
  SENT_UPDATE_TECHNOLOGY_STACK,
  props<{ apiConstants: any; updateTechStackData }>()
);
const updateTechnologyStack = createAction(UPDATE_TECHNOLOGY_STACK, props<{ technologyStackData }>());

const deleteTechnologyStack = createAction(DELETE_TECHNOLOGY_STACK, props<{ technologyStackId: string }>());

const getAppSettings = createAction(GET_APP_SETTINGS, props<{ apiConstants: any; appId: string }>());

const getSharedDbs = createAction(GET_SHARED_DATABASES, props<{ apiConstants: any; suiteId: string }>());

const setAppSettings = createAction(SET_APP_SETTINGS, props<{ settingsData: any }>());

const setSharedDbs = createAction(SET_SHARED_DB, props<{ sharedDbs: any }>());

const saveAppSettings = createAction(SAVE_APP_SETTINGS, props<{ settingsData: any }>());
const sentAppSettings = createAction(SENT_APP_SETTINGS, props<{ apiConstants: any; saveSettingsData }>());
const sentUpdateAppSettings = createAction(
  SENT_UPDATE_APP_SETTINGS,
  props<{ apiConstants: any; updateSettingsData }>()
);
const updateAppSettings = createAction(UPDATE_APP_SETTINGS, props<{ settingsData }>());

const deleteAppSettings = createAction(DELETE_APP_SETTINGS, props<{ settingsId: string }>());

const getEnvironments = createAction(
  GET_ENVIRONMENTS,
  props<{ envapiConstants: any; appId: string; searchFields: any }>()
);

const getEnvironmentsWithDb = createAction(GET_ENVIRONMENTS_DB, props<{ envapiConstants: any; params: any }>());

const setEnvironments = createAction(SET_ENVIRONMENTS, props<{ environmentDataList: any }>());

const saveEnvironments = createAction(SAVE_ENVIRONMENTS, props<{ environmentData: any }>());
const newEnvCreated = createAction(NEW_ENV_CREATED, props<{ createdEnv: any }>());
const sentEnvironments = createAction(SENT_ENVIRONMENTS, props<{ envapiConstants: any; environmentData: any }>());

const sentUpdateEnvironments = createAction(
  SENT_UPDATE_ENVIRONMENTS,
  props<{ envapiConstants: any; updateEnvironmentData: any }>()
);
const updateEnvironments = createAction(UPDATE_ENVIRONMENTS, props<{ updateEnvironmentData: any }>());
const sentDeleteEnvironments = createAction(SENT_DELETE_ENVIRONMENTS, props<{ envapiConstants: any; envId: string }>());
const deleteEnvironments = createAction(DELETE_ENVIRONMENTS, props<{ envId: string }>());
const deleteEnvironmentsFailure = createAction(
  DELETE_ENVIRONMENTS_FAILURE,
  props<{ envId: string; error: any }>()
);
const saveEnvironmentsSuccess = createAction('[Environments] Save Environments Success');

const saveEnvironmentsFailure = createAction('[Environments] Save Environments Failure', props<{ error: any }>());

export {
  createAppMetaInfo,
  deleteAppMetaInfo,
  deleteAppSettings,
  deleteEnvironments,
  deleteEnvironmentsFailure,
  deleteTechnologyStack,
  getAppMetaInfo,
  getAppSettings,
  getEnvironments,
  getEnvironmentsWithDb,
  getMemberApps,
  getSharedDbs,
  getTechnologyStack,
  getTechnologyStackBySuiteId,
  newEnvCreated,
  saveAppSettings,
  saveEnvironments,
  saveTechnologyStack,
  sentAppSettings,
  sentDeleteEnvironments,
  sentEnvironments,
  sentTeckStack,
  sentUpdateAppSettings,
  sentUpdateEnvironments,
  sentUpdateTeckStack,
  setAppMetaInfo,
  setAppSettings,
  setEnvironments,
  setMemberApps,
  setSharedDbs,
  setTechnologyStack,
  updateAppSettings,
  updateEnvironments,
  updateTechnologyStack,
  saveEnvironmentsSuccess,
  saveEnvironmentsFailure
};
